<template>
  <v-card class="my-1">
    <v-toolbar flat dense>
      <v-toolbar-title>Dankesseite</v-toolbar-title>
    </v-toolbar>
    <v-card-text>

      <!-- Dankestext -->
      <div class="d-flex align-center mb-2">
        <span class="text-body-2 font-weight-medium">Dankestext</span>
        <reset-icon :setting="thankYouText" @clear="$emit('clear', thankYouText.key)" @set-here="$emit('set-here', thankYouText.key)" />
      </div>
      <v-textarea
        filled
        :value="thankYouText.currentValue"
        @input="val => $emit('input', { key: thankYouText.key, value: val })"
        dense
        rows="4"
        hide-details
        autocomplete="off"
      ></v-textarea>

      <template v-if="socialMedia">
        <div class="section-divider"></div>

        <!-- Social Media Kanäle -->
        <div class="d-flex align-center mb-1">
          <span class="text-body-2 font-weight-medium">Teilen nach der Spende</span>
          <v-tooltip bottom max-width="280">
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-bind="attrs" v-on="on" x-small class="ml-1">{{ mdiInformationOutline }}</v-icon>
            </template>
            <span>Nach erfolgter Spende kann die Erfahrung auf SocialMedia geteilt werden. Wählen Sie, welche Kanäle dafür angeboten werden sollen.</span>
          </v-tooltip>
          <reset-icon :setting="socialMedia" @clear="$emit('clear', socialMedia.key)" @set-here="$emit('set-here', socialMedia.key)" />
        </div>
        <div class="channel-row">
          <v-checkbox
            v-for="service in socialMediaServices"
            :key="service.key"
            :input-value="socialMedia.currentValue[service.key]"
            @change="val => emitSocialMediaChange(val, service.key)"
            dense
            hide-details
            class="mt-0 pt-0 mr-4"
          >
            <template #label>
              <v-icon small class="mr-1">{{ service.icon }}</v-icon>
              <span class="text-body-2">{{ service.title }}</span>
            </template>
          </v-checkbox>
        </div>

        <div class="section-divider"></div>

        <!-- Vorausgefüllter Text -->
        <div class="d-flex align-center mb-2">
          <span class="text-body-2 font-weight-medium">Text für die SocialMedia-Posts</span>
          <reset-icon :setting="shareText" @clear="$emit('clear', shareText.key)" @set-here="$emit('set-here', shareText.key)" />
        </div>
        <div v-if="!anyChannelSelected" class="text-caption text--disabled mb-2">
          Wählen Sie oben mindestens einen Kanal aus, damit dieser Text verwendet wird.
        </div>
        <v-textarea
          filled
          :class="{ 'text--disabled': !anyChannelSelected }"
          :value="shareText.currentValue"
          @input="val => $emit('input', { key: shareText.key, value: val })"
          dense
          rows="3"
          hide-details
          autocomplete="off"
        ></v-textarea>
      </template>

      <!-- Shared placeholder legend, once -->
      <v-btn text small class="mt-3 pl-0" @click="showPlaceholders = !showPlaceholders">
        <v-icon small class="mr-1">{{ showPlaceholders ? mdiChevronUp : mdiChevronDown }}</v-icon>
        Verfügbare Platzhalter
      </v-btn>
      <v-expand-transition>
        <ul v-show="showPlaceholders" class="text-body-2 placeholder-list">
          <li v-for="v in availableTemplateVariables" :key="v.key">
            <code class="placeholder-key">%{{ v.key }}%</code>: {{ v.description }}
          </li>
        </ul>
      </v-expand-transition>
    </v-card-text>
  </v-card>
</template>

<script>
import {
  mdiInformationOutline,
  mdiChevronDown,
  mdiChevronUp,
  mdiFacebook,
  mdiInstagram,
  mdiTwitter,
  mdiEmail,
  mdiWhatsapp,
  mdiPinterest,
  mdiSnapchat,
  mdiLinkedin,
} from '@mdi/js'
import ResetIcon from '@/components/device/ResetIcon'
import { templateVariables } from '@/lib/template-db'

const SOCIAL_MEDIA_SERVICES = [
  { key: 'email', title: 'E-Mail', icon: mdiEmail },
  { key: 'whatsapp', title: 'WhatsApp', icon: mdiWhatsapp },
  { key: 'facebook', title: 'Facebook', icon: mdiFacebook },
  { key: 'instagram', title: 'Instagram', icon: mdiInstagram },
  { key: 'twitterx', title: 'X (Twitter)', icon: mdiTwitter },
  { key: 'pinterest', title: 'Pinterest', icon: mdiPinterest },
  { key: 'snapchat', title: 'Snapchat', icon: mdiSnapchat },
  { key: 'linkedin', title: 'LinkedIn', icon: mdiLinkedin },
]

export default {
  name: 'ThankYouGroup',
  components: { ResetIcon },
  props: {
    thankYouText: {
      type: Object,
      required: true,
    },
    shareText: {
      type: Object,
      default: null,
    },
    socialMedia: {
      type: Object,
      default: null,
    },
  },
  data () {
    return {
      mdiInformationOutline,
      mdiChevronDown,
      mdiChevronUp,
      socialMediaServices: SOCIAL_MEDIA_SERVICES,
      showPlaceholders: false,
    }
  },
  computed: {
    availableTemplateVariables () {
      return Object.values(templateVariables).filter(v => v.isActive)
    },
    anyChannelSelected () {
      return this.socialMedia && Object.values(this.socialMedia.currentValue || {}).some(v => v)
    },
  },
  methods: {
    emitSocialMediaChange (val, service) {
      this.$emit('input', {
        key: this.socialMedia.key,
        value: {
          ...this.socialMedia.currentValue,
          [service]: val,
        },
      })
    },
  },
}
</script>

<style scoped>
.section-divider {
  height: 1px;
  background: rgba(0, 0, 0, .08);
  margin: 20px 0;
}
.channel-row {
  display: flex;
  flex-wrap: wrap;
}
.placeholder-list {
  margin: 8px 0 0;
  padding-left: 20px;
  color: rgba(0, 0, 0, .6);
}
.placeholder-key {
  font-family: monospace;
  background-color: #eee;
  color: #666;
  padding: 0 2px;
}
</style>
